import React from 'react';
import {
  Typography,
  Button,
  Box,
  IconButton,
  useTheme,
  alpha
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { useTheme as useThemeContext } from '../../../context/ThemeContext';

const DemoNavHeader = ({ onCTAClick, onBackToLanding, isQuizMode }) => {
  const theme = useTheme();
  const { darkMode, toggleDarkMode } = useThemeContext();
  
  const handleCTAClick = () => {
    onCTAClick('header');
  };
  
  return (
    <Box sx={{ 
      borderBottom: `1px solid ${theme.palette.divider}`,
      bgcolor: alpha(theme.palette.background.default, 0.8),
      position: 'sticky',
      top: 0,
      zIndex: 10
    }}>
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        px: { xs: 2, sm: 3 },
        py: 2
      }}>
        {/* Left side - Back button and title */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <IconButton
            onClick={onBackToLanding}
            size="small"
            sx={{ 
              color: theme.palette.text.primary,
              '&:hover': { 
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                transform: 'translateX(-2px)'
              },
              transition: 'all 0.3s ease'
            }}
          >
            <ArrowBackIcon />
          </IconButton>
          
          <Box>
            <Typography 
              variant="subtitle1" 
              sx={{ 
                fontWeight: 700,
                color: theme.palette.text.primary
              }}
            >
              examr.ai
            </Typography>
            <Typography 
              variant="caption" 
              sx={{ 
                color: theme.palette.text.secondary,
                display: 'block',
                lineHeight: 1
              }}
            >
              {isQuizMode ? 'Interactive Quiz Demo' : 'Exam Preview Demo'}
            </Typography>
          </Box>
        </Box>
        
        {/* Right side - CTA and theme toggle */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Button
            variant="contained"
            startIcon={<AutoAwesomeIcon />}
            onClick={handleCTAClick}
            size="small"
            sx={{
              borderRadius: 2,
              px: 2.5,
              py: 0.8,
              fontWeight: 600,
              textTransform: 'none',
              background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
              '&:hover': {
                background: `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
                transform: 'translateY(-1px)',
                boxShadow: theme.shadows[3]
              },
              transition: 'all 0.3s ease'
            }}
          >
            Get Early Access
          </Button>
          
          <IconButton
            onClick={toggleDarkMode}
            size="small"
            sx={{ 
              color: theme.palette.text.secondary,
              '&:hover': {
                color: theme.palette.text.primary,
                backgroundColor: alpha(theme.palette.action.hover, 0.08)
              }
            }}
          >
            {darkMode ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default DemoNavHeader;
